import {maxNicknameLength} from "../constants/constants";
import bcrypt from 'bcryptjs';
import { v4 as uuidv4 } from 'uuid';

export const generateNickname = (inputString) => {
  // Generate a random 4-digit number
  let randomNumber = Math.floor(1000 + Math.random() * 9000).toString();

  // Combine input string and random number
  let combined = inputString + randomNumber;

  // Adjust length to ensure it does not exceed max characters
  if (combined.length > maxNicknameLength) {
    return combined.slice(0, maxNicknameLength); // Trim max 12 characters
  } else {
    // If shorter than 12, pad with more random numbers until length is max
    while (combined.length < maxNicknameLength) {
      combined += Math.floor(Math.random() * 10).toString(); // Append single digits
    }
    return combined;
  }
};

export const protectPass = async (pass) => {
  const saltRounds = 10;
  return await bcrypt.hash(pass, saltRounds);
}

export const generateGuid = () => {
  return uuidv4();
}